import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { useMemo } from 'react';
import { DEFAULT_ERROR_EVENTS_NAME } from '@src/emp-3.0/constants/metrics';

export const useDefaultErrorEvents = () => {
  const { predefinedMappedEvents } = useInitialInfoStore();

  const defaultErrorEvents = useMemo(() => {
    return predefinedMappedEvents.filter((i) => DEFAULT_ERROR_EVENTS_NAME.includes(i.name));
  }, [predefinedMappedEvents.length]);

  return { defaultErrorEvents };
};

export const useDefaultErrorEventIds = () => {
  const { defaultErrorEvents } = useDefaultErrorEvents();

  const errorEventIds = useMemo(() => {
    return defaultErrorEvents.map((event) => event.event_id);
  }, [defaultErrorEvents.length]);

  return { errorEventIds };
};
